import { Cell, PieChart, Pie } from "recharts"
import theme_colors from "../../../configs/theme_colors.json"

export default function GaugeChart(props) {
  const {
    gauge_value_high,
    gauge_value_middle,
    needle_value,
    width,
    height,
    x_pos,
    y_pos,
    title,
    max_value,
  } = props
  const RADIAN = Math.PI / 180
  const pie_width = width
  const pie_height = height
  let use_needle_value = 0

  if (isNaN(needle_value)) {
    use_needle_value = 0
  } else {
    use_needle_value = needle_value
  }

  const data = [
    { name: "B", value: gauge_value_middle, color: theme_colors.gauge_green },
    { name: "C", value: gauge_value_high, color: theme_colors.gauge_red },
  ]
  const cx = pie_width / x_pos
  const cy = pie_height / y_pos
  const iR = pie_width / 8
  const oR = pie_width / 4
  const value = use_needle_value

  const needle = (value, data, cx, cy, iR, oR, color) => {
    let total = 0
    data.forEach((v) => {
      total += v.value
    })

    const ang = 180.0 * (1 - value / total)
    const length = (iR + 2 * oR) / 3
    const sin = Math.sin(-RADIAN * ang)
    const cos = Math.cos(-RADIAN * ang)
    const r = 5

    const x0 = cx + 5
    const y0 = cy + 5
    const xba = x0 + r * sin
    const yba = y0 - r * cos
    const xbb = x0 - r * sin
    const ybb = y0 + r * cos
    const xp = x0 + length * cos
    const yp = y0 + length * sin

    return [
      <circle
        key="needle-base"
        cx={x0}
        cy={y0}
        r={r}
        fill={color}
        stroke="none"
      />,
      <path
        key="needle-body"
        d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
        stroke="none"
        fill={color}
      />,
      <circle
        key="needle-cover"
        cx={x0}
        cy={y0}
        r={r * 4}
        fill={"white"}
        stroke="none"
      />,
      <text
        key="needle-text"
        x={x0}
        y={y0}
        textAnchor="middle"
        fontSize={20}
        fontWeight="bold"
        fill="#333"
      >
        {Math.round(value)}
      </text>,
    ]
  }

  return (
    <div>
      <p style={{ fontSize: 14, textAlign: "center" }}>{title}</p>
      <PieChart width={pie_width} height={pie_height}>
        <Pie
          dataKey="value"
          startAngle={180}
          endAngle={0}
          data={data}
          cx={cx}
          cy={cy}
          innerRadius={iR}
          outerRadius={oR}
          fill="#8884d8"
          stroke="none"
          animationDuration={500}
        >
          {data.map((entry, index) => (
            <Cell key={entry.name || index} fill={entry.color} />
          ))}
        </Pie>
        <text x={cx - oR} y={cy + 15} textAnchor="middle" fontSize={12}>
          {/* {min_value} */}0
        </text>
        <text x={cx + oR} y={cy + 15} textAnchor="middle" fontSize={12}>
          {Math.round(max_value)}
        </text>

        {needle(value, data, cx, cy, iR, oR, "grey")}
      </PieChart>
    </div>
  )
}
